import script from "./AppBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AppBanner.vue?vue&type=style&index=0&id=b3cdb65a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3cdb65a"]])

export default __exports__